import { defineStore } from "pinia";
import { Pagination } from "@/data/base_classes/pagination";
import stores from "@/data/stores.gen";
import { can } from "@/@layouts/plugins/casl";
import { AbilityActions } from "@/plugins/casl/ability";

interface NavStore {
  badges: Record<
    string,
    {
      content: string;
      color: string;
    }
  >;
}

export const useNavStore = defineStore("navStore", {
  state: (): NavStore => ({
    badges: {},
  }),
  actions: {
    set(
      key: string,
      value: {
        content: string;
        color: string;
      },
    ): void {
      this.badges[key] = value;
    },
    get(key: string):
      | {
          content: string;
          color: string;
        }
      | undefined {
      return this.badges[key];
    },
    async init(): Promise<void> {
      for (const [key, value] of Object.entries(navQueries)) {
        const store = stores[value.entity]();
        void store
          .query(value.queries, new Pagination())
          .then(
            ({
              items,
              pagination,
            }: {
              items: any[];
              pagination: Pagination;
            }) => {
              if (items.length > 0) {
                this.set(key, {
                  content:
                    items.length.toString() +
                    (pagination.has_next_page ? "+" : ""),
                  color: "bg-primary",
                });
              } else {
                delete this.badges[key];
              }
            },
          );
      }
    },
  },
});

export function createNavStore() {
  return useNavStore();
}

const navQueries = {
  newPrintingOrders: {
    entity: "PrintingOrder",
    queries: [
      {
        field: "status",
        operator: "=",
        value: "new",
      },
    ],
  },
  waitingForSamplePrintingOrders: {
    entity: "PrintingOrder",
    queries: [
      {
        field: "status",
        operator: "=",
        value: "waiting_for_sample",
      },
    ],
  },
  waitingForApprovalPrintingOrders: {
    entity: "PrintingOrder",
    queries: [
      {
        field: "status",
        operator: "=",
        value: "waiting_for_approval",
      },
    ],
  },
  inProductionPrintingOrders: {
    entity: "PrintingOrder",
    queries: [
      {
        field: "status",
        operator: "=",
        value: "in_production",
      },
    ],
  },
  newPackingSlips: {
    entity: "PackingSlip",
    queries: [
      {
        field: "status",
        operator: "=",
        value: "shipment_not_created",
      },
    ],
  },
};
